import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import CustomSelect from "../../../utils/CustomSelect";
import { Button, Form, Input, Label, Textarea } from "../../../styles";
import { useExpensesContext } from "../../../context/expenses_context";
import Api from "../../../api/axios";
import { useUserContext } from "../../../context/user_context";
import AddExpCategory from "./AddExpCategory";
import MiniLoader from "../../../utils/MIniLoader";
import { useSupplierContext } from "../../../context/supplier_context";


const AddExpenses = (props) => {
  const [issending, setissending] = useState(false);

  const [formField, setformField] = useState({});

  const {
    showAddExpenses, CloseAddExpenses,
    openAddExpCategory,
    expCategoryData, getExpCategoryData, expCategoryLoading,
    getExpensesData
  } = useExpensesContext();

  const { usertoken, btoken, stoken } = useUserContext();

  const { supplierLoading, allSuppliers, getSupplierData, } = useSupplierContext();

  function getFn() {
    getExpCategoryData();
    getSupplierData();
  }

  function handleChange(e) {
    setformField((inputs) => ({
      ...inputs,
      [e.target.name]: e.target.value,
    }));
  }

  const category = expCategoryData?.map(({ name, id }) => {
    return (
      { label: name, value: id }
    );
  });

  const supplier = allSuppliers?.map(({ name, id }) => {
    return (
      { label: name, value: id }
    );
  });


  function clear() {
    setformField({
      details: "",
      amount: '',
      ecid: '',
      date_time: '',
      suppId: '',
    });
  }

  function submitFn(e) {
    e.preventDefault();
    if (formField.details && formField.amount && formField.ecid && formField.date_time) {
      setissending(true);
      const data = {
        usertoken, btoken, stoken,
        details: formField.details,
        amount: formField.amount,
        ecid: formField.ecid,
        date_time: formField.date_time,
        suppId: formField.suppId,
      };

      Api.post(`/addExpense`, data)
        .then((res) => {
          if (res.success === false) {
            toast.warn(res.message);
            setissending(false);
          } else {
            setissending(false);
            toast.success(res.message);
            clear();
            getExpensesData();
            CloseAddExpenses();
          }
        })
        .catch((error) => {
          setissending(false);
        });
    } else {
      setissending(false);
      toast.warn("Empty Fields !!!");
    }
  }

  return (
    <>
      <Modal
        show={showAddExpenses}
        onHide={CloseAddExpenses}
        backdrop="static"
        keyboard={true}
        onEnter={() => getFn()}
        centered
        size="lg"
      >
        <Modal.Body>
          <Modal.Header closeButton>
            <h6 className="fw-bold pry-text">
              Create new Expenses
            </h6>
          </Modal.Header>

          <div className="container">
            <Form onSubmit={(e) => submitFn(e)}>
              <Label> Category: <span>*</span>
                <MiniLoader
                  load={expCategoryLoading}
                  size={15}
                />
              </Label>
              <CustomSelect
                options={category}
                isSearchable={true}
                onChange={(e) => setformField((input) => ({ ...input, ecid: e.value }))}
                placeholder='Select Category'
                required
              />
              <p
                className="red-text text-start pointer small"
                onClick={() => openAddExpCategory()}
              >
                Category not found? add new.
              </p>

              <Label> Details: <span>*</span></Label>
              <Textarea
                type="text"
                name="details"
                placeholder="e.g. Rice"
                onChange={handleChange}
                required
                value={formField.details}
              />

              <Label> Amount: <span>*</span></Label>
              <Input
                type="text"
                name="amount"
                placeholder="Enter amount"
                onChange={handleChange}
                required
                value={formField.amount}
              />
              <Label>Supplier:
                <MiniLoader
                  load={supplierLoading}
                  size={15}
                />
              </Label>
              <CustomSelect
                options={supplier}
                isSearchable={true}
                onChange={(e) => setformField((input) => ({ ...input, suppId: e.value }))}
                placeholder='Select Supplier'
              />

              <Label> Date: <span>*</span></Label>
              <Input
                type="date"
                name="date_time"
                onChange={handleChange}
                value={formField.date_time}
                required
              />
              <div className="col-md-10 mx-auto text-center mb-4">
                <Button
                  pry
                  type="submit"
                  disabled={issending}
                  className="btn m-0 w-100"  >
                  {issending ? 'loading...' : "Submit"}
                </Button>
              </div>
            </Form>
          </div>
        </Modal.Body>
      </Modal>

      {/* Add Expenses Modal */}
      <AddExpCategory
      />
      {/* Add Expenses Modal */}
    </>
  );
};

export default AddExpenses;
